const format = (value, format) => {
  var dataObj = new Date(value)
  var date = {
    'M+': dataObj.getMonth() + 1,
    'd+': dataObj.getDate(),
    'h+': dataObj.getHours(),
    'm+': dataObj.getMinutes(),
    's+': dataObj.getSeconds(),
    'q+': Math.floor((dataObj.getMonth() + 3) / 3),
    'S+': dataObj.getMilliseconds()
  }
  if (/(y+)/i.test(format)) {
    format = format.replace(RegExp.$1, (dataObj.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in date) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1
        ? date[k] : ('00' + date[k]).substr(('' + date[k]).length))
    }
  }
  return format
}

function parseDateTime(value) {
  function add0(m) {
    return m < 10 ? '0' + m : m
  }

  var time = new Date(parseInt(value))
  var y = time.getFullYear()
  var m = time.getMonth() + 1
  var d = time.getDate()
  var h = time.getHours()
  var mm = time.getMinutes()
  var ss = time.getSeconds()

  return y + '.' + add0(m) + '.' + add0(d) ;
}
function parseLongTimeToDate(longTime) {
  if (!longTime) {
    return '';
  }
  function add0(m) {
    return m < 10 ? '0' + m : m
  }
  var time = new Date(parseInt(longTime));
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var ss = time.getSeconds();

  return y + '-' + add0(m) + '-' + add0(d)+" "+ add0(h) + ":" + add0(mm) + ":" + add0(ss);
}

export default {format,parseDateTime: parseDateTime, parseLongTimeToDate: parseLongTimeToDate}
